import { useLocation } from "react-router";

export interface FilterParams {
    query: string | null;
    types: string[];
    categories: string[];
    isFavorite: boolean;
    hasMadeIt: string | null;
}

export function useGetAppliedFiltersFromLocation(): FilterParams {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return {
        query: params.get("query"),
        types: params.getAll("type"),
        categories: params.getAll("category"),
        isFavorite: params.get("isFavorite") === "true",
        hasMadeIt: params.get("hasMadeIt")
    };
}
